import React from 'react';
import "./styles.css"
import { PiDot } from 'react-icons/pi';
import styles from '../../style';
import { motion } from 'framer-motion';

const CategoryButtons = ({ categories, selectedCategory, onSelectCategory, isScrolling }) => {
  return (
    <motion.div
      initial="initial" 
      animate="animate"
      variants={animations}
      exit={{ y: -50, opacity: 0}}
    >
      <div className={`p-4 ${styles.flexCenter}`}>
        {categories.map(category => (
          <button
            key={category}
            className={`
              p-2 px-4 bg-white h-[40px]
              ${selectedCategory === category ? 'active text-second font-bold' : ' text-second font-medium'} 
            `}
            onClick={() => onSelectCategory(category)}
          > 
          <div className='flex flex-row gap-2 items-center '>
            <PiDot className='bg-second rounded-full' color='bg-second' size={8} />
            <p className='text-ss font-semibold block truncate'>{category}</p>
          </div>
          </button>
        ))}
      </div>
    </motion.div>
  );
};

export default CategoryButtons


const animations = {
  initial: { y: -50, x: "-50%", opacity: 0 },
  animate: { 
    y: 0, 
    x: "0%", 
    opacity: 1, 
    transition: { 
      type: "spring",
      damping: 10,
      stiffness: 100,
    }  
  },
  exit: {
    y: -50,
    opacity: 1,
  }
}